/**
 * 中台接口的统一管理
 */
const tmp = {
  getPowerQualityInfo: '/api/tmp/baite/getPowerQualityInfo',//信息概览
  getPowerQualityInfoVoltageXY: "/api/tmp/baite/getPowerQualityInfoVoltageXY",//信息概览--实时曲线—线电压
  getPowerQualityInfoVoltageX: "/api/tmp/baite/getPowerQualityInfoVoltageX",//信息概览--实时曲线—相电压
  getThreePhaseUnbalance: '/api/tmp/baite/getThreePhaseUnbalance',//三相不平衡
  getRealTimeVoltageUnbalance: "/api/tmp/baite/getRealTimeVoltageUnbalance",//电压不平衡度曲线
  getRealTimeCurrentUnbalance: "/api/tmp/baite/getRealTimeCurrentUnbalance",//电流不平衡度曲线
  getFundamentalVoltage: "/api/tmp/baite/getFundamentalVoltage",//基波电压有效值曲线
  getFundamentalCurrent: "/api/tmp/baite/getFundamentalCurrent",//基波电流有效值曲线
  getRunningState: "/api/tmp/baite/getRunningState",//运行状态
  //首页配电房状态
  getTransformersSummary: "/api/tmp/baite/getTransformersSummary",//变压器概况
  getWholePlantRunningState: "/api/tmp/baite/getWholePlantRunningState",//运行状态
  getWSD: "/api/tmp/baite/getWSD",//外网温湿度
  getWholePlantEnegeSumary: "/api/tmp/baite/getWholePlantEnegeSumary",//用电概况
  getPowerRunningState: '/api/tmp/baite/getPowerRunningState',//电能使用情况
  getFlowRunningState: '/api/tmp/baite/getFlowRunningState',//流量使用情--水、蒸气
  //地图导航
  getMapNavigation: "/api/tmp/baite/getMapNavigation",//地图导航
  getEnergyStatistics: "/api/tmp/baite/getEnergyStatistics",//抄表统计
  //供电偏差
  getPowerDeviation: "/api/tmp/baite/getPowerDeviation",//供电偏差
  getPhaseVoltageDeviationRealTime: "/api/tmp/baite/getPhaseVoltageDeviationRealTime",//实时曲线-相电压偏差
  getLineVoltageDeviationRealTime: "/api/tmp/baite/getLineVoltageDeviationRealTime",//实时曲线-线电压偏差
  getFrequencyDeviationRealTime: "/api/tmp/baite/getFrequencyDeviationRealTime",//实时曲线-频率偏差
  getFrequencyRealTime: "/api/tmp/baite/getFrequencyRealTime",//实时曲线-频率
  getCurrentHarmonic: "/api/tmp/baite/getCurrentHarmonic",//谐波
  getLossAnalysis: "/api/tmp/getLossAnalysis",//损耗分析趋势
  getGroupDataInfo: "/api/tmp/getGroupDataInfo",//分类分组组合数据
  getGroupDataInfo2: "/api/tmp/getGroupDataInfo2",
  getEnergyAnalysisOfWorkingDay: "/api/tmp/getEnergyAnalysisOfWorkingDay",//工作日能耗分析
  getEnergyAnalysisOfWorkingTime: "/api/tmp/getEnergyAnalysisOfWorkingTime",//上下班能耗分析
  getCapitaConsume: "/api/tmp/getCapitaConsume",//人均单耗同环比
  getAreaConsume: "/api/tmp/getAreaConsume",//面均单耗同环比
  retrofitCompared: "/api/tmp/retrofitCompared",//改造比对能效分析
  executeCommandOnMeasure: '/api/executeCommandOnMeasure',
  getEventRecordGroupStatistics: '/api/getEventRecordGroupStatistics ',//告警列表
  getPowerRunningState: '/api/tmp/baite/getPowerRunningState',
  getAllByType: '/api/tmp/baite/getAllByType',
  getPropertyInformationOverview: "/api/tmp/getPropertyInformationOverview",//物业总览的接口
  overviewOfIndividualUsers: "/api/tmp/overviewOfIndividualUsers",//个人用户概览
  companyUserProfile: "/api/tmp/companyUserProfile",//公司用户概览
  getProprietorInformationOverview: "/api/tmp/getProprietorInformationOverview",//业主总览接口
  getEventStatisticsNumByCode: "/api/getEventStatisticsNumByCode", //根据告警类型统计告警
  getEventStatisticsNumByType: "/api/getEventStatisticsNumByType", //根据告警类型统计告警
  getElectricSaftyUseOverviewForProperty: '/api/tmp/getElectricSaftyUseOverviewForProperty',//物业用电概览

  puzzleEventSummationInfo: '/api/puzzle/puzzleEventSummationInfo',
  puzzleEventSummationInfoInPeriod: '/api/puzzle/puzzleEventSummationInfoInPeriod',

  getGroupDataInfo3: "/api/tmp/getGroupDataInfo3",
}

export default tmp;